import { useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { postUserFilterApi } from "../../../redux/features/userSlice";
import { useForm, Controller } from "react-hook-form";
import { addUser, SendEmailMobileOtp, verifyEmailOrPhoneNumberOtp  } from "../../../services/userService";
import { userRoleConstants } from "../../../utils/constants";
import { errorToast, successToast } from "../../Toasts/Toasts";
import "react-phone-number-input/style.css";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";

const ManageUserAddModal = ({ addModalShow, setAddModalShow, heading, setReRendering, reRendering, masterData, setId, transformedDataToBeFiltered, currentSize, dispatch }) => {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const page = 1;

  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [phoneCodeError, setPhoneCodeError] = useState(false);
  const { DISTRIBUTOR_USER_ID } = userRoleConstants;
  const [showEmailBox, setShowEmailBox] = useState(true);
  const [showNumberBox, setShowNumberBox] = useState(true);
  const [showEmailOtpBox, setShowEmailOtpBox] = useState(false);
  const [showNumberOtpBox, setShowNumberOtpBox] = useState(false);
  const [emailDisabled, setEmailDisabled] = useState(false);
  const [numberDisabled, setNumberDisabled] = useState(true);
  const [emailVerified, setEmailVerified] = useState(false);
  const [numberVerified, setNumberVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingNumber, setLoadingNumber] = useState(false);
  const [numberOtp, setNumberOtp] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);

  const handleModalClose = () => {
    reset();
    setAddModalShow(!addModalShow);
  };

  const onSubmit = async (formData) => {
    const formattedData = {
      ...formData,
      country_id: formData?.country?.value?.id,
      state_id: formData?.state?.value,
      commission: 0,
      role_id: DISTRIBUTOR_USER_ID,
      phone_code: phoneCode,
      phone_number: phoneNumber,
    };

    delete formattedData.country;
    delete formattedData.state;
    const button = document.getElementById("saveButton");
    try {
      if (formattedData.phone_number  !== "") {
        button.disabled = true;
        const response = await addUser(formattedData);

        if (response?.success) {
          dispatch(postUserFilterApi({ filteredData: transformedDataToBeFiltered, page, size: currentSize }));
          successToast(response?.message);
          reset();
          handleModalClose();
          button.disabled = false;
        } else {
          errorToast(response?.message);
          handleModalClose();
          button.disabled = false;
        }
      }
      else{
        setPhoneCodeError(true);
      }
    } catch (error) {
      errorToast(error?.response?.data?.message);
      button.disabled = false;
    }

    
  };

  const countryOptions = masterData?.countries?.map((countriesOption) => ({ label: countriesOption?.name, value: { code: countriesOption?.countryCode, id: countriesOption?.id } }));

  const stateOptions = masterData?.states?.map((stateOption) => ({ label: stateOption?.name, value: stateOption?.id }));

  const handleCountrySelected = (event) => {
    setId(event?.value?.code);
    setValue("state", null);
    if (errors.country) {
      setValue("country", event, { shouldValidate: true });
    }
  };

  const handleChange = (value) => {
    const stringValue = String(value);
    const parsedPhoneNumber = parsePhoneNumber(stringValue);
    if (parsedPhoneNumber) {
      setPhoneCode(`+${parsedPhoneNumber?.countryCallingCode}`);
      setPhoneNumber(parsedPhoneNumber?.nationalNumber);
      setValue("phone_number", stringValue);
      setPhoneCodeError(false);

    }
    else {
      setPhoneCode("");
      setPhoneNumber("");
      // setValue("retailer_phone_number", ""); 
    }
    if (value) {
      setValue("phone_number", value, { shouldValidate: true });
      setPhoneCodeError(false);
    }
    if(value === undefined)
    {
      setValue("phone_number", setPhoneCode, { shouldValidate: true });
      setPhoneCodeError(true);
    }
  };

  const handleStateSelected = (event) => {
    setValue("state", event);
    if (errors.state) {
      setValue("state", event, { shouldValidate: true });
    }
  };

  const sendNumberOtp = async (number) => {
    const numberVerifyButton = document.getElementById("number-verify");

    // Check if number is empty
    if (!number) {
      errorToast("Please fill the phone number field");
    } else {
      let obj = {
        mobile: number,
      };
      setLoadingNumber(true);
      setShowNumberBox(false);
      try {
        numberVerifyButton.style.pointerEvents = "none";
        const response = await SendEmailMobileOtp(obj);
        if (response?.success) {
          successToast(response?.message);
          setShowNumberBox(false);
          setShowNumberOtpBox(true);
          setLoadingNumber(false);
        } else {
          numberVerifyButton.style.pointerEvents = "auto";
          errorToast(response?.message);
          setLoadingNumber(false);
          setShowNumberBox(true);
        }
      } catch (error) {
        numberVerifyButton.style.pointerEvents = "auto";
        errorToast(error?.response?.data?.message);
      }
    }
  };

  const sendEmailOtp = async (email) => {
    const emailVerifyButton = document.getElementById("email-verify");

    // Check if email is empty
    if (!email) {
      errorToast("Please fill the email field");
    } else {
      let obj = {
        email: email,
      };
      setLoading(true);
      setShowEmailBox(false);
      try {
        emailVerifyButton.style.pointerEvents = "none";
        const response = await SendEmailMobileOtp(obj);
        if (response?.success) {
          successToast(response?.message);
          setShowEmailBox(false);
          setShowEmailOtpBox(true);
          setLoading(false);
        } else {
          emailVerifyButton.style.pointerEvents = "auto";
          errorToast(response?.message);
          setLoading(false);
          setShowEmailBox(true);
        }
      } catch (error) {
        emailVerifyButton.style.pointerEvents = "auto";
        errorToast(error?.response?.data?.message);
      }
    }
  };
  
  // Inside the verifyEmail and verifyNumber functions, update the submit button disabled state

  const verifyEmail = async (email) => {
    if (!emailOtp) {
      errorToast("Please fill the otp field");
    } else {
      let obj = {
        email: email,
        emailOtp: emailOtp,
      };
      try {
        const response = await verifyEmailOrPhoneNumberOtp(obj);
        if (response?.success) {
          successToast(response?.message);
          setShowEmailBox(true);
          setShowEmailOtpBox(false);
          setEmailDisabled(true);
          setShowEmailBox(false);
          setEmailVerified(true);
          // Check if both email and number have been verified
          if (numberOtp) {
            setSubmitButtonDisabled(false);
          }
        } else {
          errorToast(response?.message);
        }
      } catch (error) {
        errorToast(error?.response?.data?.message);
      }
    }
  };

  const verifyNumber = async (number) => {

    if (!numberOtp) {
      errorToast("Please fill the otp field");
    } else {
      let obj = {
        mobile: number,
        mobileOtp: numberOtp,
      };
      try {
        const response = await verifyEmailOrPhoneNumberOtp(obj);
        if (response?.success) {
          successToast(response?.message);
          setShowNumberBox(true);
          setShowNumberOtpBox(false);
          setNumberVerified(true);
          setShowNumberBox(false);
          setNumberDisabled(false);
          // Check if both email and number have been verified
          if (emailOtp) {
            setSubmitButtonDisabled(false);
          }
        } else {
          errorToast(response?.message);
        }
      } catch (error) {
        errorToast(error?.response?.data?.message);
      }
    }
  };

  return (
    <Modal show={addModalShow} centered>
      <div className="modal-simple">
        <div className="modal-content p-3 p-md-3">
          <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <button type="button" className="btn-close" onClick={handleModalClose} />
              <div className="text-left mb-4">
                <h3 className="mb-2">{heading}</h3>
              </div>
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Full Name</label>
                  <input type="text" {...register("name", { required: "User Name is required" })} placeholder="" className="form-control" minLength={1} maxLength={256} autoComplete="off" />
                  <small className="text-danger">{errors.name && errors.name.message}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label">Phone Number</label>
                  {numberDisabled ? (<Controller
                    name="phone_number"
                    control={control}
                    rules={{
                      required: "Required",
                    }}
                    render={({ field }) => (
                      <>
                        <PhoneInput
                          defaultCountry="AF"
                          className="form-control"
                          international
                          countryCallingCodeEditable={false}
                          value={field.value}
                          onChange={(value) => {
                            handleChange(value);
                          }}
                          autoComplete="off"
                        />
                        {phoneCodeError && <small className="text-danger">required</small>}
                        <small className="text-danger">{errors?.phone_number && errors?.phone_number?.message}</small>
                      </>
                    )}
                  />) :
                  (<input type="text" className="form-control"value={`${phoneCode} ${phoneNumber}`} disabled />)}
                </div>
                <div className="col-lg-6 mb-3">
                    {showNumberBox && (
                      <label className="btn btn-sm btn-outline-secondary waves-effect waves-light mt-4" onClick={() => sendNumberOtp(getValues("phone_number"))} id="number-verify">
                        Verify
                      </label>
                    )}
                     {loadingNumber && (
                      <div className="mt-4">
                        <span className="spinner-border h-15px w-15px align-middle text-danger" />
                      </div>
                    )}
                    {showNumberOtpBox && (
                      <div>
                        <label className="form-label">Verify OTP</label>
                        <div className="d-flex justify-content-between">
                          <input type="text" placeholder="" className="form-control" onChange={(event) => setNumberOtp(event.target.value)} />
                          <button type="button" className="btn btn-sm btn-outline-secondary waves-effect waves-light ms-2" onClick={() => verifyNumber(getValues("phone_number"))}>
                            <i className="ti ti-check" />
                          </button>
                        </div>
                      </div>
                    )}
                    {numberVerified && (
                      <label className="btn-verified mt-4">
                        Verified
                      </label>
                    )}
                  </div>
                <div className="col-lg-6  mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" {...register("email", { required: "Email is required", pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Please enter a valid email address" } })} placeholder="" className="form-control" minLength={1} maxLength={256} autoComplete="off" disabled={emailDisabled} />
                  <small className="text-danger">{errors.email && errors.email.message}</small>
                </div>
                <div className="col-lg-6 mb-3">
                    {showEmailBox && (
                      <label className="btn btn-sm btn-outline-secondary waves-effect waves-light mt-4" onClick={() => sendEmailOtp(getValues("email"))} id="email-verify">
                        Verify
                      </label>
                    )}
                    {loading && (
                      <div className="mt-4">
                        <span className="spinner-border h-15px w-15px align-middle text-danger" />
                      </div>
                    )}
                    {showEmailOtpBox && (
                      <div>
                        <label className="form-label">Verify OTP</label>
                        <div className="d-flex justify-content-between">
                          <input type="text" placeholder="" className="form-control" onChange={(event) => setEmailOtp(event.target.value)} />
                          <button type="button" className="btn btn-sm btn-outline-secondary waves-effect waves-light ms-2" onClick={() => verifyEmail(getValues("email"))}>
                            <i className="ti ti-check" />
                          </button>
                        </div>
                      </div>
                    )}
                     {emailVerified && (
                      <label className="btn-verified mt-4">
                        Verified
                      </label>
                    )}
                  </div>
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Address</label>
                  <input type="text" {...register("address", { required: "Address is required" })} placeholder="" className="form-control" minLength={1} maxLength={256} autoComplete="off" />
                  <small className="text-danger">{errors.address && errors.address.message}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label">Country</label>
                  <Controller
                    name="country"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Required",
                    }}
                    render={({ field }) => (
                      <>
                        <div className="css-b62m3t-container">
                          <Select
                            {...field}
                            options={countryOptions}
                            isMulti={false}
                            onChange={(selectedOption) => {
                              setValue("country", selectedOption);
                              handleCountrySelected(selectedOption);
                            }}
                          />
                        </div>
                        <small className="text-danger">{errors?.country && errors?.country?.message}</small>
                      </>
                    )}
                  />
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label">State</label>
                  <Controller
                    name="state"
                    control={control}
                    defaultValue=""
                    rules={{ required: "State is required" }}
                    render={({ field }) => (
                      <>
                        <div className="css-b62m3t-container">
                          <span id="react-select-5-live-region" className="css-1f43avz-a11yText-A11yText" />
                          <span aria-live="polite" aria-atomic="false" aria-relevant="additions text" role="log" className="css-1f43avz-a11yText-A11yText" />
                          <Select
                            {...field}
                            options={stateOptions}
                            isMulti={false}
                            onChange={(selectedOption) => {
                              handleStateSelected(selectedOption);
                            }}
                          />
                        </div>
                        {errors.state && <small className="text-danger">{errors.state.message}</small>}
                      </>
                    )}
                  />
                </div>

                <div className="col-lg-6  mb-3">
                  <label className="form-label">City</label>
                  <input type="text" {...register("city", { required: "City is required" })} placeholder="" className="form-control" minLength={1} maxLength={256} autoComplete="off" />
                  <small className="text-danger">{errors.city && errors.city.message}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label">Zip</label>
                  <input type="number" {...register("zip", { required: "ZIP Code is required" })} placeholder="" className="form-control" autoComplete="off" />
                  <small className="text-danger">{errors.zip && errors.zip.message}</small>
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-center mt-4">
                  <button type="submit" className="btn btn-primary rounded-pill me-sm-3 me-1 waves-effect waves-light" id="saveButton" disabled={submitButtonDisabled}>
                    Submit
                  </button>
                  <button type="button" className="btn btn-label-secondary rounded-pill btn-reset waves-effect" onClick={handleModalClose}>
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ManageUserAddModal;
